import { ProductBuilderMachineContext } from '../types';
import { getBaseProduct } from './getBaseProduct';

type GetTiltPositionOptions = (
  context: ProductBuilderMachineContext,
) => string[];

export const getTiltPositionOptions: GetTiltPositionOptions = context => {
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return [];
  const {
    metafields: { tilt_position },
  } = baseProduct;
  return tilt_position ? tilt_position : [];
};
